import React, { useState, useEffect } from "react";
// eslint-disable-next-line
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from "reactstrap";
import ComputeTabItems from "./ComputeTabItems";
import StorageTabItems from "./StorageTabItems";
import NetworkTabItems from "./NetworkTabItems";
import SecurityTabItems from "./SecurityTabItems";
import DatabaseTabItems from "./DatabaseTabItems";
import CollaborationTabItems from "./CollaborationTabItems";

function ExploreProductsTabs(props) {
    // Tabs Selection
    const [activeTab, setActiveTab] = useState("1");
    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const [mobile, setMobile] = useState(false);
    useEffect(() => {
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            setMobile({ mobile: true });
        }
    }, []);

    return (
        <Row>
            <Nav tabs vertical className="pt-2">
                {/* Compute */}
                <NavItem className="product-button mb-1 mb-1">
                    <NavLink onClick={() => toggle("1")}>
                        <Row className="row">
                            <Col sm="2">
                                <img src={require("../../assets/Detasad Cloud/icon_computer.svg")} alt=""></img>
                            </Col>
                            <Col sm="8" className="pt-2">
                                <p className="button-text">Compute</p>
                            </Col>
                        </Row>
                    </NavLink>
                </NavItem>
                {/* Storage */}
                <NavItem className="product-button mb-1">
                    <NavLink onClick={() => toggle("2")} className="nav nav-tabs">
                        <Row className="row">
                            <Col sm="2">
                                <img src={require("../../assets/Detasad Cloud/icon_storage_old.svg")} alt=""></img>
                            </Col>
                            <Col sm="8" className="pt-2">
                                <p className="button-text">Storage</p>
                            </Col>
                        </Row>
                    </NavLink>
                </NavItem>
                {/* Networks */}
                <NavItem className="product-button mb-1">
                    <NavLink onClick={() => toggle("3")} className="nav nav-tabs">
                        <Row className="row">
                            <Col sm="2">
                                <img src={require("../../assets/Detasad Cloud/icon_network.svg")} alt=""></img>
                            </Col>
                            <Col sm="8" className="pt-2">
                                <p className="button-text">Network</p>
                            </Col>
                        </Row>
                    </NavLink>
                </NavItem>
                {/* Database */}
                <NavItem className="product-button mb-1">
                    <NavLink onClick={() => toggle("4")} className="nav nav-tabs">
                        <Row className="row">
                            <Col sm="2">
                                <img src={require("../../assets/Detasad Cloud/icon_detabase.svg")} alt=""></img>
                            </Col>
                            <Col sm="8" className="pt-2">
                                <p className="button-text">Database</p>
                            </Col>
                        </Row>
                    </NavLink>
                </NavItem>
                {/* Security */}
                <NavItem className="product-button mb-1">
                    <NavLink onClick={() => toggle("5")} className="nav nav-tabs">
                        <Row className="row">
                            <Col sm="2">
                                <img src={require("../../assets/Detasad Cloud/icon_security_old.svg")} alt=""></img>
                            </Col>
                            <Col sm="8" className="pt-2">
                                <p className="button-text">Security</p>
                            </Col>
                        </Row>
                    </NavLink>
                </NavItem>
                {/* Collaboration & Communication */}
                <NavItem className="product-button mb-1">
                    <NavLink onClick={() => toggle("6")} className="nav nav-tabs">
                        <Row className="row">
                            <Col sm="2">
                                <img src={require("../../assets/Detasad Cloud/icon_communication_old.svg")} alt=""></img>
                            </Col>
                            <Col sm="8" className="pt-2">
                                <p className="button-text">Collaboration & Communication</p>
                            </Col>
                        </Row>
                    </NavLink>
                </NavItem>
            </Nav>
            <Col md="9">
                <TabContent className={!mobile ? "text-left" : ""} activeTab={activeTab}>
                    <TabPane tabId="1">
                        <ComputeTabItems />
                    </TabPane>
                    <TabPane tabId="2">
                        <StorageTabItems />
                    </TabPane>
                    <TabPane tabId="3">
                        <NetworkTabItems />
                    </TabPane>
                    <TabPane tabId="4">
                        <DatabaseTabItems />
                    </TabPane>
                    <TabPane tabId="5">
                        <SecurityTabItems />
                    </TabPane>
                    <TabPane tabId="6">
                        <CollaborationTabItems />
                    </TabPane>
                </TabContent>
            </Col>
        </Row>
    );
}

export default ExploreProductsTabs;
